/**
 * Identificatore casuale pseudonimo per la prova del consenso.
 * Non deriva da UA, schermo o fuso e viene creato solo durante la registrazione.
 */

export const VISITOR_KEY = 'emerge-privacy-visitor-uid';

function randomBytes(n: number): string {
  const arr = new Uint8Array(n);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(arr);
  } else {
    for (let i = 0; i < n; i++) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function getVisitorUid(): string {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing && existing.length >= 24) return existing;
    const next = randomBytes(16);
    localStorage.setItem(VISITOR_KEY, next);
    return next;
  } catch {
    // fallback session-only
    return randomBytes(16);
  }
}

/** Ritorna il visitor_uid corrente SENZA generarne uno nuovo se assente. */
export function peekVisitorUid(): string | null {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing && existing.length >= 24) return existing;
    return null;
  } catch {
    return null;
  }
}

/** Cancella il visitor_uid (per GDPR Art. 17 right to erasure). */
export function clearVisitorUid(): void {
  try {
    localStorage.removeItem(VISITOR_KEY);
  } catch {
    /* ignore */
  }
}
